import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { getParticipantID } from "@10x/sso";
import Strings from "@my-dld/assets/strings";
import { I8N } from "@eres/core";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { Redirect } from "react-router";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { RTRegistrationContext } from "@my-dld/contexts/RTRegistrationContext";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import { JQModal } from "@my-dld/components/Popup/Utils";
import RTOfficeOnMapPopup from "@my-dld/components/RTRegistration/RTOfficeOnMapPopup";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import {
	Procedure,
	ProcedureCategory,
	ProcedureTransaction,
	REQ_SOURCE_DLD_WEB,
	Role,
	RTOffice,
	sortByOfficeName
} from "@eres/rtregistrationapi/entities";
import { RTRegistrationApi } from "@eres/rtregistrationapi";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../MyDLD/PropertyDetails";

interface Props extends RoutedViewProps {

}

interface State {
	tabuPropertyId?: number;
	property?: AssetCard;
	procedureCategories: ProcedureCategory[];
	procedureCategory?: ProcedureCategory;
	procedureTypes: Procedure[];
	procedureType?: Procedure;
	rtOffices: RTOffice[];
	rtOffice?: RTOffice;
	showMap?: boolean;
	error: { [ k: string ]: string };
}

class ProcedureSelection extends Component<Props, State> {
	static contextType = RTRegistrationContext;
	context!: React.ContextType<typeof RTRegistrationContext>;

	constructor( props: Props ) {
		super( props );
		const tabuPropertyId = this.props.match.params ? this.props.match.params.tabuPropertyId : undefined;
		const property = props.location.state ? props.location.state.property : undefined;
		this.state = {
			property: property,
			tabuPropertyId: tabuPropertyId,
			rtOffices: [],
			procedureCategories: [],
			procedureTypes: [],
			error: {},
		};
	}

	componentDidMount() {
		const savedState = this.context.getData( "ProcedureSelection" );
		if ( savedState ) {
			this.setState( {
				...savedState as State,
			} );
		} else if ( this.state.tabuPropertyId )
			this.loadRTOffices();
	}

	render() {
		const state = this.state;
		if ( state.tabuPropertyId == null || state.property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( state.property );
		return <PageContent
			title={ `${ Strings.rt_register_transaction_at_rt_office } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.rt_register_transaction_at_rt_office } paths={ [ DashboardBCItem ] }/>
			<div className="row">
				<div className="col-md-12 online-registration-form" id="proceed-form">
					<div className="card">
						<div
							className="card-header font-weight-bold">{ Strings.rt_select_procedure_type }</div>
						<div className="card-body">
							<div className="mb-3">
								<small>{ Strings.mandatory_fields_note }</small>
							</div>
							<div className="row">
								<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
									<PickerInput
										id={ "procedureCategory" }
										holder={ this }
										required={ true }
										label={ Strings.rt_registration_for }
										items={ state.procedureCategories }
										formatter={ ( item: ProcedureCategory ) => I8N.isRTL() ? item.CategoryArabicName : item.CategoryEnglishName }
										toIdentifier={ ( item: ProcedureCategory ) => "" + item.CategoryId }
										error={ this.state.error.procedureCategory }
										onValueChange={ ( cat?: ProcedureCategory ) => {
											if ( cat ) this.loadProcedureTypes( cat );
										} }/>
								</div>
								<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
									<PickerInput
										id={ "procedureType" }
										holder={ this }
										required={ true }
										label={ Strings.procedure_type }
										items={ state.procedureTypes }
										formatter={ ( item: Procedure ) => I8N.isRTL() ? item.ProcedureNameArabic : item.ProcedureNameEnglish }
										toIdentifier={ ( item: Procedure ) => "" + item.ProcedureId }
										error={ this.state.error.procedureType }/>
								</div>
							</div>
							<div className="row">
								<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
									<div className="form-group">
										<label htmlFor={ "rtOffice" }><span>{ Strings.rt_office }</span>
                                            <span className="asterisk">*</span>
										</label>
										<PickerInput
											id={ "rtOffice" }
											holder={ this }
											required={ true }
											items={ state.rtOffices }
											formatter={ ( item: RTOffice ) => I8N.isRTL() ? item.NameAr : item.NameEn }
											toIdentifier={ ( item: RTOffice ) => "" + item.Identity }
											error={ this.state.error.rtOffice }
											containerClassName={ "input-group field-style select-control" }>
											<div className="input-group-append">
												<button
													className="btn btn_1" type="button"
													onClick={ this.showRTOfficesOnMap }>
													<i className="fa fa-map-marker-alt"/></button>
											</div>
										</PickerInput>
									</div>
								</div>
								<div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
									<div className="form-group btn-align-wrap">
										<button
											className="btn btn_1 btn_style1" type="submit"
											onClick={ this.onProceed }>{ Strings.proceed }</button>
										<button
											type="button" className="btn btn-link"
											onClick={ this.onReset }>{ Strings.reset }</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{ state.showMap && <RTOfficeOnMapPopup
				rtOffices={ state.rtOffices }
				onDismiss={ this.onModelDismiss }/> }
		</PageContent>;
	}

	private loadRTOffices() {
		showLoading();
		RTRegistrationApi.loadRTOffices().then( ( resp: any ) => {
			const rtOffices = sortByOfficeName( resp.OfficeList );
			this.loadProcedureCategories( rtOffices );
		} ).catch( reason => {
			this.loadProcedureCategories( [] );
		} );
	}

	private loadProcedureCategories( offices: RTOffice[] ) {
		RTRegistrationApi.loadProcedureCategories( this.state.tabuPropertyId!, getParticipantID()! ).then( ( resp: any ) => {
			hideLoading();
			this.setState( {
				rtOffices: offices,
				procedureCategories: resp.CategoryResponseDetail,
			} );
		} ).catch( reason => {
			hideLoading();
			this.setState( {
				rtOffices: offices,
				procedureCategories: [],
			} );
		} );
	}

	private loadProcedureTypes( cat: ProcedureCategory ) {
		showLoading();
		this.setState( {
			procedureTypes: [],
			procedureType: undefined,
		}, () => {
			RTRegistrationApi.loadProcedures( this.state.tabuPropertyId!, cat.CategoryId, getParticipantID()! ).then( ( resp: any ) => {
				hideLoading();
				this.setState( {
					procedureTypes: resp.PropertyStatusCategoryDetail,
				} );
			} ).catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		} );
	}

	private onProceed = () => {
		if ( this.isValid() ) {
			this.initProcedure();
		}
	};

	private onReset = () => {
		this.setState( {
			procedureCategory: undefined,
			procedureTypes: [],
			procedureType: undefined,
			rtOffice: undefined,
		} );
	};

	private isValid() {
		let isValid = true;
		const { procedureCategory, procedureType, rtOffice } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( procedureCategory == undefined ) {
			error.procedureCategory = Strings.required;
			isValid = false;
		}
		if ( procedureType == undefined ) {
			error.procedureType = Strings.required;
			isValid = false;
		}
		if ( rtOffice == undefined ) {
			error.rtOffice = Strings.required;
			isValid = false;
		}
		this.setState( {
			error: error,
		} );
		return isValid;
	}

	private initProcedure() {
		showLoading();
		const { tabuPropertyId, procedureType, rtOffice } = this.state;
		RTRegistrationApi.initProcedure( tabuPropertyId!, procedureType!.ProcedureId, getParticipantID()! ).then( ( resp: any ) => {
			hideLoading();
			const procedure: ProcedureTransaction = resp.InitProcedureResponse;
			if ( procedure.ValidationErrors && procedure.ValidationErrors.length > 0 ) {
				this.trackEvent( false );
				showErrorMessage( RTRegistrationApi.getValidationError( procedure.ValidationErrors ) );
			} else {
				procedure.RequestSource = REQ_SOURCE_DLD_WEB;
				procedure.procedureId = procedureType!.ProcedureId;
				procedure.propertyId = tabuPropertyId!;
				procedure.RTOfficeParticipantId = rtOffice!.ParticipantId;
				if ( procedure.Roles && procedure.Roles.length > 0 ) {
					procedure.Roles = procedure.Roles.sort( ( a: Role, b: Role ) => a.RoleOrder - b.RoleOrder );
				}
				this.trackEvent( true );
				this.context.setData( "ProcedureSelection", this.state );
				navigateWithInParent( "rt", "registration", undefined, { procedure: procedure } );
			}
		} ).catch( reason => {
			hideLoading();
			showErrorMessage( reason );
		} );
	}

	private trackEvent( isSuccess: boolean ) {
		const { tabuPropertyId, procedureType, rtOffice } = this.state;
		const action = isSuccess ? "InitProcedureSuccess" : "InitProcedureFail";
		trackEventWithData( "RTRegistration", action, {
			procedureId: "" + procedureType!.ProcedureId,
			tabuPropertyId: "" + tabuPropertyId,
			rtOfficeParticipantId: "" + rtOffice!.ParticipantId,
		} );
	}

	private showRTOfficesOnMap = () => {
		this.setState( {
			showMap: true,
		}, () => {
			JQModal( "RTOfficeOnMapPopup" ).show();
		} );
	};

	private onModelDismiss = ( office?: RTOffice ) => {
		this.setState( {
			showMap: false,
			rtOffice: office ? office : this.state.rtOffice,
		} );
	};
}

export default ProcedureSelection;
